import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { post } from '@util/xhrAPI'
import { updateSterilizationCallFormObject, clearSterilizationCallForm, updateErrors } from "@store/slice/sterilizationSlice"
import { updateNotification, updateValidationPage } from '@store/slice/mainSlice'
import { useEffect, useState } from "react"
import useMainData from '@hook/useMainData'
import useStoreUpdate from "@hook/useStoreUpdate"
import useToggle from "@hook/useToggle"
import useFormData from "@hook/useFormData"
import Div from '@ui/layout/Div'
import Form from '@ui/elements/Form'
import sterilizationCitizenCallFormFields, { sterilizationCitizenCallSaveUrl } from "@form/sterilizationCitizenCallFormFields"
import { useNavigate } from "react-router"
import { ROLE_PUBLIC } from "@router/Routes"
import useHtmlRenderer from '@hook/useHtmlRenderer'
import useGoogleRecaptchaTokenizer from "@hook/useGoogleRecaptchaTokenizer"

const CitizenSterilizationCallMaker = () => {
  const { sterilizationCitizenCallFormObject, errors } = useSelector(state => state.sterilization)
  const { data, mission, rgpdPage } = useSelector(state => state.main)
  const [userCoordinates, setUserCoordinates] = useState(null)
  const dispatch = useDispatch()
  const loadData = useMainData()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updateSterilizationCallFormObject, sterilizationCitizenCallFormObject)
  const [isLoading, toggleLoading] = useToggle(false)
  const [t] = useTranslation('sterilization')
  const renderFormData = useFormData()
  const navigate = useNavigate()
  const renderHtml = useHtmlRenderer()
  const [invokeChallenge, appendScript] = useGoogleRecaptchaTokenizer()
  appendScript()

  const generateFormStep = step => {
    return sterilizationCitizenCallFormFields(
      step,
      sterilizationCitizenCallFormObject,
      updateFormObject,
      updateFormObjectProp,
      errors,
      saveForm,
      isLoading,
      t,
      data
    )
  }

  const fetchInitialData = () => {
    const dataObject = {
      cities: 'cities',
      districts: 'districts'
    }
    loadData(dataObject)
  }

  const saveForm = async () => {
    toggleLoading()
    const token = await invokeChallenge(updateFormObjectProp)
    const callObject = { ...sterilizationCitizenCallFormObject, 'g-recaptcha-response': token }
    post(sterilizationCitizenCallSaveUrl, renderFormData(callObject, ['userCoordinates']), response => {
      const { validationPage, code, errors } = response
      if (200 === code) {
        dispatch(updateNotification({ type: 'is-success', message: t('messages.call_created_successfuly') }))
        dispatch(updateValidationPage(validationPage))
        dispatch(clearSterilizationCallForm())
        navigate(ROLE_PUBLIC['publicValidation'])
      } else {
        dispatch(updateErrors(errors))
        dispatch(updateNotification({ type: 'is-danger', message: t(`messages.${errors.length ? errors[0] : 'errors_encountered'}`) }))
      }

      toggleLoading()
    })
  }

  const updateUserCoordinates = () => {
    if (window.innerWidth <= 768) { //get user location if on mobile
      navigator.geolocation.getCurrentPosition(function (position) {
        setUserCoordinates({ lat: position.coords.latitude, lng: position.coords.longitude })
      })
    }
  }

  useEffect(() => {
    updateFormObjectProp('mission', mission.id)
    fetchInitialData()
    updateUserCoordinates()
  }, [])

  useEffect(() => {
    if (userCoordinates) {
      updateFormObjectProp('userCoordinates', userCoordinates)
    }
  }, [userCoordinates])

  return (
    <Div cssCalss='sterilization-request-maker'>
      <h2 className="scene-title">{t('titles.citizen_sterilization_call_maker')}</h2>
      <Form cssClass='citizen-sterilization-call columns'>
        <Div cssClass='left-form column is-6'>
          <Div cssClass='columns is-multiline'>
            {generateFormStep('caller')}
          </Div>
        </Div>
        <Div cssClass='right-form column is-6'>
          <Div cssClass='columns is-multiline'>
            {generateFormStep('call')}
          </Div>
        </Div>
      </Form>
      <Div cssCalss='cms-content'>
        {renderHtml(rgpdPage.description)}
      </Div>
    </Div>
  )
}

export default CitizenSterilizationCallMaker